import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const StepCont = styled.div`
  flex: 1;
`;
export const Heading = styled.h3`
  font-size: 28px;
  line-height: 33px;
  color: #000;
  font-weight: 900;
  @media ${device.mobileS} {
    font-size: 22px;
    line-height: 28px;
  }
`;
export const SubHeading = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: #000;
  margin-top: 4px;
  span {
    font-weight: 700;
  }
  @media ${device.mobileS} {
    font-size: 14px;
  }
`;
export const TncText = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: #000;
  margin-top: 80px;
  span {
    font-weight: 900;
  }
`;

export const TopContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  @media ${device.mobileS} {
    flex-direction: column;
  }
`;
export const TopContentLft = styled.div`
  flex: 1;
  position: relative;
`;
export const TopContentRht = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  margin-left: 30px;
  @media ${device.mobileS} {
    margin-left: unset;
    margin-top: 16px;
  }
  p {
    max-width: 250px;
    text-align: center;
  }
`;
export const TopContentTitle = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: #000;
  @media ${device.mobileS} {
    font-size: 14px;
    line-height: 16px;
  }
`;
export const TopContentSubTitle = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #000;
  margin-top: 4px;
  span {
    font-weight: 700;
  }
`;

export const SpinnerCont = styled.div`
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LegalName = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  > * {
    &:first-child {
      width: 20%;
      //margin-top: 10px !important;
    }
    &:nth-child(3) {
      width: 60%;
      margin-top: 28px;
    }
  }
`;

export const ErrorMsg = styled.p`
  color: #eb2026;
  font-size: 16px;
  font-weight: 400;
  margin-top: 22px;
`;

export const TitleWrapper = styled.div(
  props => `
          width:9.5rem;
          position: relative;
          flex-direction: column;
      `,
);

export const CommonLabel = styled.label(
  props => `
        font-size: 16px;
        color: #000;
        font-weight: bold;
        display: flex;
        margin-bottom: 10px;
        line-height: 19px;
    `,
);

export const CommonInputWrap = styled.div(
  props => `
          width:100%;
          display: flex;
          flex-direction: column;
          position: relative;
    `,
);
